module.exports = __webpack_public_path__ + "img/4-low.b9f1337a.jpg";